import axios from 'axios';
import { DEV_BASE_URL } from '../../constants';
import { toastFlashMessage } from '../index';
import { extractErrorMessages, shouldIgnoreError } from './helper';

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = DEV_BASE_URL;
axiosInstance.interceptors.request.use(
  (config) => {
    const oktaTokenStorage = JSON.parse(
      localStorage.getItem('okta-token-storage')
    );
    if (oktaTokenStorage?.accessToken?.accessToken) {
      config.headers.Authorization = `Bearer ${oktaTokenStorage.accessToken.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      response.ok = true;
    }
    return response;
  },
  (error) => {
    if (error.response?.status < 500) {
      // TCR-20747 Navigate to home for further handling when profile is no longer active
      if (error.response.data && error.response.data.code === 330) {
        throw error;
      }
      if (
        error.response.data &&
        error.response.data.error &&
        Object.keys(error.response.data.error)
      ) {
        const messages = extractErrorMessages(error.response.data);
        error.response.data.errorMessages = messages;
        if (!error.config.silent) {
          toastFlashMessage(messages, 'error');
        }
      } else if (shouldIgnoreError(error.response)) {
        //
      }
      return error.response;
    } else {
      if (!error?.config?.silent) {
        toastFlashMessage(
          'Unable to process the request due to technical error',
          'error'
        );
      }
      return error;
    }
  }
);

const setupRedirectInterceptor = (history) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.data && error.response.data.code === 330) {
        history.push('/');
      }
      return error;
    }
  );
};

export default axiosInstance;
export { setupRedirectInterceptor };
